var toggleSearch = function(){

  var body;
  var buttons;
  var input;
  var billboard;

  var _init = function(){
    body = document.body;
    if(document.querySelector('.m-banner--billboard')){
      billboard = document.querySelector('.m-banner--billboard');
    }
    buttons = document.querySelectorAll('[data-function="toggle-search"]');
    input = document.getElementById('searchField');
    document.addEventListener('click', _documentOnClick);

    _addEventListeners();
  }

  var _addEventListeners = function(){
    [].map.call(buttons, function(button){
      button.addEventListener('click', _toggleSearch);
    });
  }

  var _toggleSearch = function(){

    console.log(_isMobile());

    if (!_isMobile()) {
      // Align searchbox around Leaderboard
      var searchBox = document.querySelector('#m-search-container');
      var masthead = document.querySelector('.m-masthead');

      if (searchBox) {
        searchBox.style.top = (masthead.offsetHeight + searchBox.offsetHeight + document.querySelector('.m-main-header').offsetTop) + "px";
      }
    }

    body.classList.toggle('is-search-active');

    window.addEventListener('keydown', _onkeyDown);

    if(!body.classList.contains('is-search-active')){
      input.blur();
    }else{
      console.log(input);
      input.focus();
    }

    _removeActiveMenu();
  }

  var _removeActiveMenu = function(){
    if (body.classList.contains('is-mobile-menu-active')) {
      body.classList.remove('is-mobile-menu-active');
    }
  }

  var _onkeyDown = function(e){
    if (!document.body.classList.contains('is-search-active')) {return;};

    if (e.key === 'Escape') {
      _removeClass(body, 'is-search-active');
    }
  };

  var _documentOnClick = function(e){
    if (!document.body.classList.contains('is-search-active')) {return;};

    if (e.target.classList.contains('m-main-content')) {
      _removeClass(body, 'is-search-active');
    }
  };

  var _removeClass = function(el, className){
    el.classList.remove(className);
  }

  var _isMobile = function(){
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  }


  return {
    init: _init
  }

}();


toggleSearch.init();
